import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Avatar from '@material-ui/core/Avatar';
import VersionHistorySVG from 'assets/images/svg/versionControl/VersionHistorySVG';
import hexToRgba from 'hex-to-rgba';

const useStyles = makeStyles(theme => ({
    root: {
        width: props => props.width,
        height: props => props.height,
        borderRadius: '50%',
        '& svg': {
            width: props => props.iconSize,
            height: props => props.iconSize
        },
        cursor: 'pointer'
    }
}));

const SIZES = {
    small: {
        width: 32,
        height: 32,
        iconSize: 16
    },
    medium: {
        width: 48,
        height: 48,
        iconSize: 20
    }
};

function getSize(size) {
    switch (size) {
        case 'small':
            return SIZES['small'];
        case 'medium':
            return SIZES['medium'];
        default:
            return SIZES['small'];
    }
}

function BranchIcon({ color, icon = <VersionHistorySVG />, size = 'small', className, ...rest }) {
    const { width, height, iconSize } = getSize(size);
    const classes = useStyles({
        width,
        height,
        iconSize
    });

    return (
        <Avatar
            className={`${classes.root} ${className}`}
            style={{
                background: hexToRgba(color, 0.8),
                border: `1px solid ${hexToRgba(color, 1)}`
            }}
            {...rest}
        >
            {typeof icon === 'function' ? icon() : icon}
        </Avatar>
    );
}

export default React.memo(BranchIcon);
